import React from "react";
import dummyezi from "../../../assets/images/dummy/dummyezi.png";

const ShopDummyCard = ({ isProperty }) => {
  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 p-2">
      <div
        className="ShopsCards mt-2 mb-2"
        style={{ boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)" }}
      >
        {!isProperty ? (
          <div className="fix-img position-relative">
            <img
              className="card-img img-fluid"
              src={dummyezi}
              alt="Selectezi"
              style={{
                objectFit: "cover",
                width: "100%",
                height: "-webkit-fill-available",
              }}
              crossOrigin="anonymous"
            />
          </div>
        ) : (
          <img
            className="card-img img-fluid"
            src={dummyezi}
            alt="Selectezi"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "-webkit-fill-available",
            }}
            crossOrigin="anonymous"
          />
        )}
        <div
          className="border d-flex align-items-center justify-content-center"
          style={{ height: "120px" }}
        >
          <p
            className="mb-0 items-card-font font-blue text-center"
            style={{ color: "#0353A4" }}
          >
            Explore with Selectezi
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShopDummyCard;
